<template>
  <div>
    <h1>帳號管理</h1>
    <button class="btn btn-primary" @click="newUser()">新增</button>
    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
<!--        <th>ID <input class="form-control"  v-model="filters.id" @input="applyFilters" /></th>-->
        <th>姓名 <input class="form-control"  v-model="filters.name" @input="applyFilters" /></th>
        <th>電子郵件(登入帳號) <input class="form-control"  v-model="filters.email" @input="applyFilters" /></th>
        <th>密碼</th>
        <th>備註 <input class="form-control"  v-model="filters.address1" @input="applyFilters" /></th>
        <th>已停用</th>
        <th>操作</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, index) in filteredUsers" :key="index">
<!--        <td>{{ user.id }}</td>-->
        <td><input class="form-control"  v-model="user.name" /></td>
        <td><input class="form-control"  v-model="user.email" /></td>
        <td><input class="form-control"  type="password" v-model="user.password" @input="user.passwordModified = true" /></td>
<!--        <td><input class="form-control"  v-model="user.status" /></td>-->
        <td><input class="form-control"  v-model="user.address1" /></td>
        <td>
          <span v-if="user.deleted_at">停用</span>
        </td>
        <td>
          <button class="btn btn-primary" @click="saveUser(user)">儲存</button>
          <span v-if="user.deleted_at">
            <button class="btn btn-danger" @click="enableUser(user)" >啟用</button>
          </span>
          <span v-if="!user.deleted_at">
            <button class="btn btn-danger" @click="deleteUser(user)" v-if="user.name !=='admin' && user.id">停用</button>
          </span>


        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";

export default {
  data() {
    return {
      users: [],
      filters: {
        id: '',
        name: '',
        email: '',
        status: '',
        mtel: '',
        address1: '',
        address2: '',
        sex: '',
        deleted_at: false
      }
    };
  },
  computed: {
    filteredUsers() {
      return this.users.filter(user => {
        return Object.keys(this.filters).every(key => {
          if (key === 'deleted_at') {
            return this.filters[key] ? user[key] : true;
          }
          return String(user[key]).includes(this.filters[key]);
        });
      });
    }
  },
  methods: {
    loadUsers() {
      apiFireGodsec.api_Admin_AdminUsers_List().then((response) => {
        this.users = response.data.data.map(user => ({ ...user, passwordModified: false }));
      });
    },
    newUser() {
      this.users.push({
        id: '',
        name: '',
        email: '',
        password: '',
        mtel: '',
        address1: '',
        address2: ''
      });
    },
    saveUser(user) {
      debugger // eslint-disable-line
      //validate
      if (user.id){
        //修改
        if (!user.name || !user.email ) {
          alert('請輸入姓名、電子郵件');
          return;
        }
      }else{
        //新增
        if (!user.name || !user.email || !user.password) {
          alert('請輸入姓名、電子郵件、密碼');
          return;
        }
      }


      apiFireGodsec.api_Admin_AdminUsers_Save(user).then((response) => {
        alert('儲存成功');
        this.loadUsers();
      });
    },
    enableUser(user){
      apiFireGodsec.api_Admin_AdminUsers_Enable(user).then((response) => {
        alert('啟用成功');
        this.loadUsers();
      });
    },
    deleteUser(user) {
      //show delete confirm
      if(confirm('確定要停用嗎?')) {
        apiFireGodsec.api_Admin_AdminUsers_Delete(user).then((response) => {
          alert('停用成功');
          this.loadUsers();
        });
      }
    },
    isDuplicateMtel(mtel, id) {
      return this.users.some(user => user.mtel === mtel && user.id !== id);
    },
    applyFilters() {
      // This method is intentionally left empty as the filtering is handled by the computed property
    }
  },
  mounted() {
    this.loadUsers();
  }
};
</script>

<style scoped>
.table {
  width: 100%;
}
input {
  width: 100%;
}
button {
  margin: 5px;
}
</style>
